<template>
    <biller-modal :isVisible="shouldShow">
        <div class="pt-24 px-16 md:px-24 pb-12">
            <p class="text-grey-300 text-base font-semibold text-center">Payment Successful</p>
            <div class="my-12 relative h-48 flex items-center justify-center">
                <img src="@/assets/svg/trophy.svg" />
            </div>
            <div class="flex items-center justify-center pt-10">
                <button
                    class="rounded-lg bg-orange-pale px-8 py-4 text-orange font-semibold text-base"
                    @click="$emit('go-to-dashboard')"
                >
                    Go to Dashboard
                </button>
            </div>
        </div>
    </biller-modal>
</template>

<script>
export default {
    props: {
        shouldShow: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped></style>
